module.exports = __webpack_public_path__ + "static/img/banner-word-en.cfd0ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/img/banner-word-en.png
// module id = tnpT
// module chunks = 97